import { RefObject, useEffect, useRef } from 'react';
import { useReducedMotion } from 'hooks/useReducedMotion';
import { scrollCarouselItemToBeVisible } from 'utils/scrollCarouselItemToBeVisible';
import { useVerticalSystemContext } from '../VerticalSystemContext/VerticalSystemContext';

export function useVerticalSystemCarouselScroll(rootRef: RefObject<HTMLElement>) {
  const { activeVariant, activeTabItem } = useVerticalSystemContext();
  const scrollLeft = useRef(0);
  const shouldReduceMotion = useReducedMotion();
  const behavior = (shouldReduceMotion ? 'instant' : 'smooth') as ScrollBehavior;

  useEffect(() => {
    const container = getContainer(rootRef.current);
    const target = container?.querySelector(`[aria-controls="sect-${activeTabItem?.id}-${activeVariant}"]`);
    if (!container || !target) return;

    scrollLeft.current = scrollCarouselItemToBeVisible(container, target, {
      offset: 16,
      behavior,
    });
  }, [activeVariant, activeTabItem]);

  useEffect(() => {
    const container = getContainer(rootRef.current);
    container?.scroll({ left: scrollLeft.current });
  }, [activeTabItem]);
}

function getContainer(root: HTMLElement | null) {
  return root?.querySelector(
    '[role="tabpanel"]:not([hidden]) [role="scrollbar"][aria-orientation="horizontal"]',
  );
}
